import axiosInstance from "@/axiosInstance";

const state = () => ({
  suppliers: [],
  purchases: [],
  receivables: [],
  warehouses: [],
  supplyChainLoaded: false,
});

const mutations = {
  SET_SUPPLIERS(state, suppliers) {
    state.suppliers = suppliers;
  },
  SET_PURCHASES(state, purchases) {
    state.purchases = purchases;
  },
  SET_WAREHOUSES(state, warehouses) {
    state.warehouses = warehouses;
  },
  SET_RECEIVABLES(state, receivables) {
    state.receivables = receivables;
  },
  SET_SUPPLY_CHAIN_LOADED(state, loaded) {
    state.supplyChainLoaded = loaded;
  },
  CLEAR_SUPPLY_CHAIN_DATA(state) {
    state.suppliers = [];
    state.purchases = [];
    state.receivables = [];
    state.supplyChainLoaded = false;
  },
};

const actions = {
  async fetchSupplyChainData({ state, commit }) {
    if (state.supplyChainLoaded) return;
    try {
      const [supplierRes, purchaseRes, receivableRes, warehouseRes] = await Promise.all([
        axiosInstance.get("suppliers/"),
        axiosInstance.get("purchases/"),
        axiosInstance.get("stock-receivables/"),
        axiosInstance.get("warehouses/"),

      ]);
      commit("SET_SUPPLIERS", supplierRes.data);
      commit("SET_PURCHASES", purchaseRes.data);
      commit("SET_RECEIVABLES", receivableRes.data);
      commit("SET_WAREHOUSES", warehouseRes.data);
      commit("SET_SUPPLY_CHAIN_LOADED", true);
    } catch (error) {
      console.error("Failed to fetch onboard data:", error);
    }
  }
};

const getters = {
  getSuppliers: (state) => state.suppliers,
  getPurchases: (state) => state.purchases,
  getReceivables: (state) => state.receivables,
  getWarehouses: (state) => state.warehouses,
  isSupplyChainLoaded: (state) => state.supplyChainLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};